import React from 'react';
import { useNumberOfMultipleItem } from 'hooks';
import { MultipleTasksIcon } from './MultipleTasksIcon';

export const MultipleTasksIconContainer = ({ ...props }) => {
  const number = useNumberOfMultipleItem();
  return number ? <MultipleTasksIcon number={number} {...props} /> : null;
};
